/**
 * Fenêtre d'affichage du rappel "sécuriser le dossier avec une tâche" affiché
 * quand un utilisateur quitte une fiche prospect.
 * Règle (validée) : visible pour TOUS pendant 30 jours après le lancement,
 * ET pendant les 30 premiers jours pour les comptes nouvellement créés.
 */

// Lancement de la fonctionnalité : 2026-06-09 → fin de fenêtre globale à +30 jours.
const GLOBAL_HINT_UNTIL = new Date('2026-07-09T23:59:59');
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

export function shouldShowLeaveHint(user) {
    const now = new Date();
    if (now <= GLOBAL_HINT_UNTIL) return true;
    if (user?.created_at) {
        const created = new Date(user.created_at);
        if (!isNaN(created.getTime()) && now <= new Date(created.getTime() + THIRTY_DAYS_MS)) return true;
    }
    return false;
}
